module.exports = __webpack_public_path__ + "img/1517312717.d793df61.jpg";